import { classExists } from "../helper/class-exists";
import { clickButton } from "../helper/click-button";
import { videoIframe } from "./video-embed";

const awardsModal = (button) => {
	const buttonData = button.dataset.award;
	const awardData = JSON.parse(atob(buttonData));
	const awardModal = document.querySelector("#award-modal");

	const videoId = awardData.award_video_id;
	const awardYear = awardData.broker_award_year;
	const awardName = awardData.broker_award_name;
	const details = awardData.broker_award_details;
	const awardImg = awardData.award_image_url;
    const brokerReviewURL = awardData.broker_review_url;
    const brokerVisitURL = awardData.broker_visit_url;

	awardModal.querySelector(".iframe-container").dataset.youtubeUrl = videoId;
	awardModal.querySelector(".video-duration").innerHTML = awardYear;
	awardModal.querySelector(".video-captions .title").innerHTML = awardName;
	awardModal.querySelector(".video-captions .description").innerHTML = details;

	awardModal.querySelector(".award-img").setAttribute("src", awardImg);

	awardModal
		.querySelector(".iframe-container")
		.querySelector(".play-button")
		.classList.remove("hide");
	awardModal.querySelector(".iframe-container").classList.add("is-loading");
    awardModal.querySelector(".modal-review").setAttribute("href", brokerReviewURL);
    awardModal.querySelector(".modal-visit").setAttribute("href", brokerVisitURL);
	videoIframe(".js-video-single");
};

const awardsButton = () => {
	const buttons = document.querySelectorAll(".see-award-button");
	classExists(buttons);

	clickButton(buttons, (button) => awardsModal(button));
};

document.addEventListener("DOMContentLoaded", function () {
	awardsButton();
	
});

const triggerAwardButtonViaURL = () => {
	if (window.location.hash) {
		let currentHashValue = window.location.hash.slice(1);
		let allYears = [...document.querySelectorAll('.tab-btn')].map((tab) => { return tab.innerText; });
		let allAwardBrokers = [...document.querySelectorAll('.the-award-card')].map((card) => { return card.dataset.awardCard; });
		let awardYearBroker = currentHashValue.split('_');
		if (awardYearBroker.length === 2 && allYears.includes(awardYearBroker[0]) && allAwardBrokers.includes(awardYearBroker[1])) {
			// if the hash is valid and exists within the cards and tabs
			setTimeout(() => {
				document.querySelector('.tab-btn[data-year-tab="' + awardYearBroker[0] + '"]').click(); // click the tab
				let awardCardButtonIdentifier = '.see-award-button[data-award-modal-identifier="' + currentHashValue + '"]';
				document.querySelector(awardCardButtonIdentifier).click(); // click the see award button
			}, 100);
		}
	}
};

window.addEventListener('load', () => {
	triggerAwardButtonViaURL();
});
// also track hash changes in awards
window.addEventListener('hashchange', () => {
	triggerAwardButtonViaURL();
});
